import mixpanel from 'mixpanel-browser';
import { isProd } from './trackingService';
import { DelayedCalls } from './delayedCalls';
class MixpanelService extends DelayedCalls {
    init(prodToken, testToken) {
        if (!this.isInitialized) {
            const currentToken = isProd() ? prodToken : testToken;
            mixpanel.init(currentToken);
            super.initialize(mixpanel);
        }
    }
    track(event, properties) {
        this.makeCall(c => c.track(event, properties));
    }
    alias(id, email) {
        this.makeCall(c => {
            if (id) {
                c.alias(id.toLowerCase(), email);
            }
        });
    }
    tryIdentify(email) {
        this.makeCall(c => {
            if (email) {
                c.identify(email.toLowerCase());
            }
        });
    }
    setPeople(user) {
        this.makeCall(c => c.people.set(user));
    }
}
export const MixpanelInstance = new MixpanelService();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWl4cGFuZWwuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsidHJhY2tpbmcvbWl4cGFuZWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxRQUFzQyxNQUFNLGtCQUFrQixDQUFBO0FBQ3JFLE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQTtBQUMxQyxPQUFPLEVBQUUsWUFBWSxFQUFFLE1BQU0sZ0JBQWdCLENBQUE7QUFhN0MsTUFBTSxlQUFnQixTQUFRLFlBQXNCO0lBQ2xELElBQUksQ0FBRSxTQUFpQixFQUFFLFNBQWlCO1FBQ3hDLElBQUksQ0FBQyxJQUFJLENBQUMsYUFBYSxFQUFFO1lBQ3ZCLE1BQU0sWUFBWSxHQUFHLE1BQU0sRUFBRSxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQTtZQUNyRCxRQUFRLENBQUMsSUFBSSxDQUFDLFlBQVksQ0FBQyxDQUFBO1lBQzNCLEtBQUssQ0FBQyxVQUFVLENBQUMsUUFBUSxDQUFDLENBQUE7U0FDM0I7SUFDSCxDQUFDO0lBRUQsS0FBSyxDQUFFLEtBQWEsRUFBRSxVQUFpQjtRQUNyQyxJQUFJLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxLQUFLLEVBQUUsVUFBVSxDQUFDLENBQUMsQ0FBQTtJQUNoRCxDQUFDO0lBRUQsS0FBSyxDQUFFLEVBQVUsRUFBRSxLQUFhO1FBQzlCLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLEVBQUU7WUFDaEIsSUFBSSxFQUFFLEVBQUU7Z0JBQ04sQ0FBQyxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUMsV0FBVyxFQUFFLEVBQUUsS0FBSyxDQUFDLENBQUE7YUFDakM7UUFDSCxDQUFDLENBQUMsQ0FBQTtJQUNKLENBQUM7SUFFRCxXQUFXLENBQUUsS0FBYztRQUN6QixJQUFJLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxFQUFFO1lBQ2hCLElBQUksS0FBSyxFQUFFO2dCQUNULENBQUMsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLFdBQVcsRUFBRSxDQUFDLENBQUE7YUFDaEM7UUFDSCxDQUFDLENBQUMsQ0FBQTtJQUNKLENBQUM7SUFFRCxTQUFTLENBQUUsSUFBa0I7UUFDM0IsSUFBSSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUE7SUFDeEMsQ0FBQztDQUNGO0FBRUQsTUFBTSxDQUFDLE1BQU0sZ0JBQWdCLEdBQUcsSUFBSSxlQUFlLEVBQUUsQ0FBQSJ9